import { API } from "@brg/api";

type SubmitFormParams = {
  email: string;
  name: string;
  token: string;
};

// Кастомный submit form, код для iq

export const submitForm = async ({ email, name, token }: SubmitFormParams) => {
  const url = "/feedback_requests";

  const formData = new FormData();

  formData.append("authenticity_token", token);
  formData.append("sp_list_id", "3652");
  formData.append("feedback_request[return_url]", "https://iq-media.ru/lk");
  formData.append("feedback_request[form_id]", "496");
  formData.append("feedback_request[event_mail_trigger]", "");
  formData.append("feedback_request[price]", "");
  formData.append("feedback_request[utm_source]", "");
  formData.append("feedback_request[utm_medium]", "");
  formData.append("feedback_request[utm_campaign]", "");
  formData.append("feedback_request[utm_content]", "");
  formData.append("feedback_request[utm_term]", "");
  formData.append("form_data[email]", email);
  formData.append("form_data[name]", name);

  try {
    const response = await API.fetch(url, {
      method: "POST",
      body: formData,
    });

    if (response.status === 200) {
      window.location.replace('/subscribe/thank-you');
    }
  } catch (error) {
    console.log(error);
  }
};
import { API } from "@brg/api";

type SubmitFormParams = {
  email: string;
  name: string;
  token: string;
};

// Кастомный submit form, код для iq

export const submitForm = async ({ email, name, token }: SubmitFormParams) => {
  const url = "/feedback_requests";

  const formData = new FormData();

  formData.append("authenticity_token", token);
  formData.append("sp_list_id", "3652");
  formData.append("feedback_request[return_url]", "https://iq-media.ru/lk");
  formData.append("feedback_request[form_id]", "496");
  formData.append("feedback_request[event_mail_trigger]", "");
  formData.append("feedback_request[price]", "");
  formData.append("feedback_request[utm_source]", "");
  formData.append("feedback_request[utm_medium]", "");
  formData.append("feedback_request[utm_campaign]", "");
  formData.append("feedback_request[utm_content]", "");
  formData.append("feedback_request[utm_term]", "");
  formData.append("form_data[email]", email);
  formData.append("form_data[name]", name);

  try {
    const response = await API.fetch(url, {
      method: "POST",
      body: formData,
    });

    if (response.status === 200) {
      window.location.replace('/subscribe/thank-you');
    }
  } catch (error) {
    console.log(error);
  }
};
